"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Article = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var color_1 = require("@theme-ui/color");
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var sticky_svg_1 = __importDefault(require("../../styles/Icons/assets/sticky.svg"));
var article_fallback_png_1 = __importDefault(require("./article-fallback.png"));
var ArticleBase_1 = require("./ArticleBase");
function Article(_a) {
    var title = _a.title, locale = _a.locale, csx = _a.csx, timestamp = _a.timestamp, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? "transparent" : _b, _c = _a.backgroundImage, backgroundImage = _c === void 0 ? article_fallback_png_1.default : _c, _d = _a.isSticky, isSticky = _d === void 0 ? false : _d, onClick = _a.onClick, _e = _a.articlePosition, articlePosition = _e === void 0 ? ArticleBase_1.ArticlePosition.MIDDLE : _e;
    return (theme_ui_1.jsx(ArticleBase_1.ArticleBase, { backgroundImage: backgroundImage, backgroundColor: backgroundColor, onClick: onClick, articlePosition: articlePosition, csx: csx },
        theme_ui_1.jsx(theme_ui_1.Heading, { sx: {
                height: 3,
                overflow: "hidden",
                position: "relative",
                textIndent: isSticky ? __1.theme.space[2] : 0,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                "::before": {
                    background: "url(" + sticky_svg_1.default + ")",
                    content: "''",
                    display: isSticky ? "block" : "none",
                    height: "12px",
                    left: 0,
                    position: "absolute",
                    top: 0,
                    transform: "translateY(50%)",
                    width: "12px"
                }
            }, as: "h2", variant: "text.p" }, title),
        theme_ui_1.jsx(__1.Date, { locale: locale, timestamp: timestamp, csx: { color: color_1.alpha(__1.theme.colors.white, 0.7) } })));
}
exports.Article = Article;
